import { EPropertyMemberTypes } from "@rentiohq/shared-frontend/dist/types/property.types";
import {
  EField,
  IExtraData,
} from "./schema.requestRentioMoveServiceExit.types";

export const getInitialValues = (extraData: IExtraData) => {
  const { property, contract } = extraData;

  const owners =
    property?.members.filter(member =>
      member.roles.includes(EPropertyMemberTypes.Owner),
    ) || [];

  const firstOwner = owners[0];

  // Default to 'yes' (vacancy contract)
  // DepartingTenant will be set dynamically by the schema when VacancyPropertyContract is 'no'
  return {
    [EField.MoveDate]: contract?.stopDate || new Date(),
    [EField.VacancyPropertyContract]: "yes",
    [EField.VacancyPropertyContractHolder]: firstOwner
      ? [firstOwner.account.id]
      : undefined,
  };
};
